import { FadedImage } from "../../FadedImage";

const A = "/brand";
const IMG = `${A}/blueprint4joy-about-hands-eyes.jpg`;
const ALT = "Lara making binoculars with her hands over her eyes, tongue out, mid laugh.";

export function QuickToLaugh() {
  return (
    <section data-testid="about-quick-to-laugh" className="relative overflow-hidden bg-[#FFFFFF]">
      <div className="relative w-full overflow-hidden reveal pb-10 lg:pb-0">
        {/* Desktop image half-band, left side */}
        <div className="hidden lg:block absolute inset-y-0 left-0 w-[42%]">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="quick-to-laugh-image"
            bg="#FFFFFF"
            objectPosition="50% 22%"
            featherRight={44}
            featherTop={10}
            featherBottom={10}
            className="absolute inset-0"
          />
        </div>

        {/* Mobile image stacked on top */}
        <div className="lg:hidden relative w-full aspect-[4/5] mt-2">
          <FadedImage
            src={IMG}
            alt={ALT}
            testId="quick-to-laugh-image-mobile"
            bg="#FFFFFF"
            objectPosition="50% 18%"
            featherBottom={20}
            className="absolute inset-0"
          />
        </div>

        {/* Text on the clean right */}
        <div className="relative z-[2] max-w-7xl mx-auto px-6 md:px-10 pt-8 lg:pt-0 flex items-center justify-end lg:min-h-[min(58vh,480px)]">
          <div className="w-full lg:w-[52%]">
            <div className="max-w-[480px] lg:ml-auto">
              <p
                data-testid="quick-to-laugh-header"
                className="font-display text-[38px] md:text-[61px] text-[#159E9A] leading-snug mb-5"
              >
                Childlike wonder never came with an expiration date.
              </p>
              <div
                data-testid="quick-to-laugh-body"
                className="space-y-4 text-[23px] md:text-[37px] leading-[1.75] text-[#57534E]"
              >
                <p>
                  I&rsquo;m the person who asks one more question, imagines one
                  more possibility and occasionally turns ordinary moments into
                  stories worth remembering.
                </p>
                <p>
                  That curiosity has led me to remarkable places, wonderful
                  people and more than a few ridiculous adventures.
                </p>
                <p>
                  It&rsquo;s also taught me that the most interesting
                  conversations rarely begin with the obvious questions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
